import { onRejectReasonChange } from '../../../dispatcher.slice';
import { OtherReasonDraftInput } from './OtherReasonDraftInput';
import { RejectionReasonSelect } from './RejectionReasonSelect';
import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import {
  composeOtherReason,
  parseOtherReason,
} from 'src/features/trip/management/cancel/otherReason';

export function RejectionReasonSelectionCell({ tripId }: { tripId: string }) {
  const dispatch = useAppDispatch();
  const storedReason = useAppSelector(
    (state) =>
      state.dispatcher.modals.requestedTripIdsToRejectToReasonCodes[tripId]
  );
  const { reason, otherText } = parseOtherReason(storedReason || '');

  const setReason = (value: string | null) => {
    dispatch(onRejectReasonChange({ tripId, reason: value }));
  };

  return (
    <div className="flex flex-col gap-1">
      <RejectionReasonSelect
        tripId={tripId}
        value={reason || undefined}
        onChange={(selected) => setReason(selected?.value || null)}
      />
      {reason === 'other' ? (
        // Keyed on the stored value so any external write (e.g. a future
        // global type-once box) remounts the draft instead of going stale.
        // Self-commits also remount, harmlessly: blur already ended editing
        // and the re-initialized draft equals what was just committed.
        // Unmounts when a non-Other reason is picked, so the draft can't
        // outlive its stored value.
        <OtherReasonDraftInput
          key={storedReason || ''}
          initialText={otherText}
          ariaLabel="Other rejection reason"
          dataTestId={`reject-other-reason-input-${tripId}`}
          onCommit={(text) => {
            const composed = composeOtherReason(text);
            if (composed !== storedReason) {
              setReason(composed);
            }
          }}
        />
      ) : null}
    </div>
  );
}
